import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import FieldController from '../../../controller/FieldController';
import ApiUiController from '../../../controller/ApiUiController';
import Util from '../../../util/Util';
import FieldAssigment from '../automation/FieldAssigment';
import AutomationAssigmnent from '../automation/AutomationAssigmnent';
import RegEx from '../../../util/RegEx';

class Acres99Update extends React.Component {

  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);

    this.state = {
      inApiCall: id !== 0, id: id, name: '', method: Const.False,
      username: '', password: '', inValid: {}
    };
    this.fields = [{ key: 'Name', field: 'firstname' },
    { key: 'Email', field: 'email' },
    { key: 'Phone', field: 'phone' },
    { key: 'CmpctLabl', field: 'description' }];
    this.assigments = [{ field: 'source', value: 0 }];
    this.basePath = this.props.match.path;
    const model = reactLocalStorage.getObject(Const.Model);
    this.model = model.lead;
    this.modelFields = FieldController.getFilterFields(this.model.fields);
    this.users = model.user.options;
    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/add-edit'));
  }

  componentDidMount() {
    if (this.state.id !== 0) { ThirdPartyAPI.get(this.state.id, this.onReceived, this.onFail); }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = api => {

    const data = JSON.parse(api.api_data);

    this.fields = JSON.parse(api.fields);
    this.fields = this.fields.length !== 0 ? this.fields : [{}];

    this.assigments = JSON.parse(api.assigments);
    this.assigments = this.assigments.length !== 0 ? this.assigments : [{}];

    this.setState({
      ...this.state, inApiCall: false, id: api.id,
      name: api.name, method: api.method, username: data.username, password: data.password
    });
  };

  keyChange = (key, event) => {
    const state = { ...this.state };
    state[key] = event.target.value;
    this.setState({ ...this.state, ...state });
  };
  methodChange = tog => this.setState({ ...this.state, method: tog ? Const.True : Const.False });

  onSave = () => {
    let inValid = {};
    if (this.state.name.trim() === '') inValid = { ...inValid, name: 'Invalid Field' };
    if (this.fields.length === 0) inValid = { ...inValid, fields: 'Invalid Field' };

    if (Object.keys(inValid).length === 0) {
      this.setState({ ...this.state, inApiCall: true });

      const api_data = JSON.stringify({
        username: this.state.username,
        password: this.state.password
      });

      const api = {
        id: this.state.id, name: this.state.name, method: this.state.method,
        fields: JSON.stringify(this.fields), assigments: JSON.stringify(this.assigments),
        type: 2, model_no: 1, party_type: 6, api_data
      };
      ThirdPartyAPI.save(api, this.onSaved, this.onFail);
    } else {
      Util.showNotification('Form incomplete', 'Please fill all information', 'danger');
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  addField = () => { this.fields.push({}); this.setState({ ...this.state, inValid: {} }); };
  editField = (index, field) => this.fields[index] = field;
  deleteField = index => {
    this.fields = this.fields.filter((_, i) => i !== index);
    this.setState({ ...this.state, inValid: {} });
  };
  addAssign = () => { this.assigments.push({}); this.setState({ ...this.state, inValid: {} }); };
  editAssign = (index, assigment) => this.assigments[index] = assigment;
  deleteAssign = index => {
    this.assigments = this.assigments.filter((_, i) => i !== index);
    this.setState({ ...this.state, inValid: {} });
  };

  render() {
    const inValid = this.state.inValid;

    return (
      <div className="sectionform pt-4 ">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12 pb-4"><h3>99 Acre</h3></div>
          </div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Name'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')}`}
                    value={this.state.name} onChange={evt => this.keyChange('name', evt)} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Username'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'username')}`}
                    value={this.state.username} onChange={evt => this.keyChange('username', evt)} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Password'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'password')}`}
                    value={this.state.password} onChange={evt => this.keyChange('password', evt)} />
                </div>
              </div>


              <div className="formhead col-md-12"><h4>Fields</h4></div>
              <FieldAssigment fields={this.modelFields} value={this.fields}
                onAdd={this.addField} onEdit={this.editField} onDelete={this.deleteField} />

              <AutomationAssigmnent fields={this.modelFields}
                assigments={this.assigments} model={this.model}
                onAdd={this.addAssign} onEdit={this.editAssign} onDelete={this.deleteAssign} />

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(Acres99Update);